import { ColorSwatch } from "@salestrak/ui";
import { OUTCOME_TONE_CONFIG, type OutcomeTone } from "#app/lib/outcome-tone";

/**
 * The tone marker for an outcome — green / grey / red.
 *
 * Lives on the Outcomes settings page and nowhere else. Tone describes how an
 * interaction went so an admin can scan the vocabulary and so reporting can
 * group it; picking a word to post is not that act, so the posting pickers
 * (`FollowUpOutcomePicker`, `ProjectOutcomePicker`) are deliberately
 * undecorated. Adding a dot to one of those re-teaches the reader that tone
 * matters at post time, when it does not.
 */
export function OutcomeToneDot({ tone }: { tone: OutcomeTone }) {
  return (
    <ColorSwatch
      color={OUTCOME_TONE_CONFIG[tone].swatch}
      size="xs"
      rounded="full"
    />
  );
}
